export default __webpack_public_path__ + "static/media/add-social-media-icon.c2ce9856.svg";